import BarcodeScannerButton from "./BarcodeScannerButton";

export default BarcodeScannerButton;
export type { BarcodeScannerButtonProps } from "./BarcodeScannerButton.d";
